import { Autocomplete, TextField } from '@mui/material';

import { ATSAutomationCreateTestIds } from 'data-testids/ATS';
import { QuestionComboBoxProps } from 'features/Automations/types';

export const QuestionComboBox: React.FC<QuestionComboBoxProps> = ({ onChange, options, value }) => {
  return (
    <Autocomplete
      data-testid={ATSAutomationCreateTestIds.SELECT_QUESTION_COMBOBOX}
      getOptionLabel={(option) => option.question || option.prompt || ''}
      onChange={onChange}
      options={options}
      value={value}
      renderInput={(params) => (
        <TextField
          placeholder={'Select a question'}
          {...params}
          InputLabelProps={{
            shrink: false,
          }}
        />
      )}
      sx={{
        '.MuiInputBase-root': {
          borderRadius: '10px',
        },
        '& .MuiAutocomplete-input': {
          '&::placeholder': {
            opacity: 1,
          },
        },
      }}
    />
  );
};
